module.exports = __webpack_public_path__ + "static/mobile-1-970e94644e6200f9040a5890dec3ab10.png";